/**
 * Wie wat mag in het beheer (SPEC §2).
 *
 * Een rol beschrijft een taak, geen persoon; iemand draagt er één of meer en
 * de rechten tellen op. Hier en niet in de Worker, zodat de knoppen in het
 * scherm dezelfde grens aanhouden als de API erachter. De sluiting zit in de
 * Worker; een knop weglaten is opmaak.
 */

export type Rol = 'penningmeester' | 'bestuur' | 'applicatiebeheerder' | 'meelezer';

export const ROLNAMEN: Record<Rol, string> = {
  penningmeester: 'Penningmeester',
  bestuur: 'Bestuur',
  applicatiebeheerder: 'Applicatiebeheerder',
  meelezer: 'Meelezer',
};

export const ALLE_ROLLEN: readonly Rol[] = [
  'penningmeester',
  'bestuur',
  'applicatiebeheerder',
  'meelezer',
];

function heeft(rollen: readonly Rol[], ...gezocht: Rol[]): boolean {
  return rollen.some((rol) => gezocht.includes(rol));
}

/** Helden en betalingen muteren: betaald zetten, opzeggen, incasso draaien. */
export function magMuteren(rollen: readonly Rol[]): boolean {
  return heeft(rollen, 'penningmeester', 'bestuur', 'applicatiebeheerder');
}

/** Tarieven, drempels, afzender. (De teksten op de site staan in de code.) */
export function magInstellingenBeheren(rollen: readonly Rol[]): boolean {
  return heeft(rollen, 'applicatiebeheerder');
}

export function magGebruikersBeheren(rollen: readonly Rol[]): boolean {
  return heeft(rollen, 'applicatiebeheerder');
}

export function rollenAlsZin(rollen: readonly Rol[]): string {
  const namen = rollen.map((r) => ROLNAMEN[r]);
  if (namen.length <= 1) return namen[0] ?? '';
  return `${namen.slice(0, -1).join(', ')} en ${namen.at(-1)}`;
}

export function alsRol(waarde: unknown): Rol | null {
  return ALLE_ROLLEN.includes(waarde as Rol) ? (waarde as Rol) : null;
}
